/* SolarBalls — shared horizontal product slider.
   Wires any container marked [data-sb-slider] that holds a [data-sbh-track] row
   plus optional [data-sbh-prev]/[data-sbh-next] arrows. Same behaviour as the
   home Best Sellers carousel: click-to-scroll, snap, disabled-state, drag-to-scroll. */
(function(){
  if (window.SBSlider) return;

  function initSlider(root){
    if (!root || root.dataset.sbSliderInit) return;
    var track = root.querySelector('[data-sbh-track]');
    if (!track) return;
    root.dataset.sbSliderInit = '1';

    var prev = root.querySelector('[data-sbh-prev]');
    var next = root.querySelector('[data-sbh-next]');

    function step(){ var c = track.querySelector('.sbh-bs__card, .sbx-card'); return c ? c.getBoundingClientRect().width + 16 : 250; }
    function update(){
      var max = track.scrollWidth - track.clientWidth - 24;
      if (prev) prev.disabled = track.scrollLeft <= 24;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var raf;
    track.addEventListener('scroll', function(){ cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* drag-to-scroll (mouse/trackpad press-drag) */
    var down = false, sx = 0, ss = 0, moved = false;
    track.addEventListener('pointerdown', function(e){ if (e.pointerType === 'touch') return; down = true; moved = false; sx = e.clientX; ss = track.scrollLeft; });
    window.addEventListener('pointermove', function(e){ if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4){ moved = true; track.classList.add('is-dragging'); } track.scrollLeft = ss - dx; });
    window.addEventListener('pointerup', function(){ if (down){ down = false; setTimeout(function(){ track.classList.remove('is-dragging'); }, 0); } });
    track.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  function initAll(){ document.querySelectorAll('[data-sb-slider]').forEach(initSlider); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  window.SBSlider = { init: initAll, initOne: initSlider };
})();
